export enum ServiceType {
  Bike = 'Bike',
  ChefStudio = 'ChefStudio',
  Coworking = 'Coworking',
  GameRoom = 'GameRoom',
  Grill = 'Grill',
  Gym = 'Gym',
  HairStylist = 'HairStylist',
  Massage = 'Massage',
  MeetingRoom = 'MeetingRoom',
  PartyRoom = 'PartyRoom',
  SteamRoom = 'SteamRoom',
  Washer = 'Washer',
  FightRoom = 'FightRoom',
  SquashCourt = 'SquashCourt',
  TenisCourt = 'TenisCourt',
  MultiSportCourt = 'MultiSportCourt',
  Pool = 'Pool',
  Default = 'Default',
}

export default ServiceType;
